import { render } from "./Pedir.vue?vue&type=template&id=45ce5efc"
import script from "./Pedir.vue?vue&type=script&lang=js"
export * from "./Pedir.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Usuario\\Desktop\\prueba\\Blooz\\blooz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__